<template>
  <!-- 剧集抽屉 -->
  <a-drawer title="广告解锁剧集" width="700" :closable="false" :visible="visible" @close="onClose"
    :footer-style="{ textAlign: 'right' }">
    <a-form ref="RefForm" :model="formState" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
      <!-- 每日可解锁 -->
      <a-form-item label="每日可解锁" name="daily_unlock" :rules="[{ required: true, validator: validatorPrice }]">
        <a-input v-model:value="formState.daily_unlock" placeholder="请输入" suffix="次" />
      </a-form-item>
      <!-- 安卓广告ID -->
      <a-form-item label="安卓广告ID" name="ad_id" :rules="[{ required: true, message: '请输入' }]">
        <a-input v-model:value="formState.ad_id" placeholder="请输入" />
      </a-form-item>
      <!-- iOS广告ID -->
      <a-form-item label="iOS广告ID" name="ios_ad_id" :rules="[{ required: true, message: '请输入' }]">
        <a-input v-model:value="formState.ios_ad_id" placeholder="请输入" />
      </a-form-item>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
      <a-button type="primary" @click="touchSubmit">确定</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { ref, reactive, nextTick } from 'vue'
import { message } from 'ant-design-vue'
import Loading from '@/components/Loading'
import Pub from '@/utils/public'
import { cashAdUnlockSave, dramaDetail, dramaEdit } from '@/api/appfront'

const emit = defineEmits('success')
// Form实例
const RefForm = ref(null)
// 抽屉展示状态
let visible = ref(false)
// 加载
let isLoading = ref(false)
// name
let id = ref(undefined)
// 剧集信息
let formState = reactive({
  // 每日可解锁
  daily_unlock: undefined,
  // 安卓广告ID
  ad_id: undefined,
  // iOS广告ID
  ios_ad_id: undefined,
})

// 打开抽屉
function showDrawer(record) {
  visible.value = true
  id.value = record.id
  formState.daily_unlock = record.ad_times_total
  formState.ad_id = record.ad_id
  formState.ios_ad_id = record.ios_ad_id
  // // 获取详情
  // getDetail()
}

// 获取详情
function getDetail() {
  dramaDetail({ id: id.value }).then(res => {
    const { code, data } = res
    console.log(res)

    if (code === 0) {
      let info = data.info
      formState.daily_unlock = info.daily_unlock
      formState.ad_id = info.ad_id
      formState.ios_ad_id = info.ios_ad_id
    }
  })
}

// 关闭抽屉
function onClose() {
  if (!isLoading.value) {
    RefForm.value.resetFields()
    visible.value = false
    formState.daily_unlock = undefined
    formState.ad_id = undefined
    formState.ios_ad_id = undefined
  }
}

// 提交
function touchSubmit() {
  RefForm.value.validate().then((() => {
    isLoading.value = true
    // 准备数据
    const params = {
      id: id.value,
      ad_times_total: formState.daily_unlock,
      ad_id: formState.ad_id,
      ios_ad_id: formState.ios_ad_id,
    }
    cashAdUnlockSave(params).then(res => {
      isLoading.value = false
      const { code, msg, data } = res
      if (code === 0) {
        message.success('保存成功')
        onClose()
        emit('success')
      } else {
        message.error(res.message || msg)
      }
    })
  }))
}

// 效验 - 价格
function validatorPrice(rule, value) {
  if (!value) {
    return Promise.reject('请输入')
  } else if (!Pub.REG_IS_POSITIVE_INTEGER(value)) {
    return Promise.reject('必须为正整数')
  }
  return Promise.resolve()
}
// 暴露出去
defineExpose({
  showDrawer
})

</script>

<style lang="less" scoped></style>